/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import { qreq } from "../shared/qrequest";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import Globals from "../shared/Globals";
import { Link } from "react-router-dom";
import ScrollHandler from "./ScrollHandler";
import './CommentList.css';
import { Alert } from "react-bootstrap";

const colorMap = ["rgb(0,0,255)", "rgb(37,102,118)", "rgb(191,205,142)", "rgb(156,35,53)", "rgb(45,173,184)", "rgb(204,141,150)", "rgb(27,225,159)", "rgb(97,59,79)", "rgb(150,234,78)", "rgb(128,80,199)", "rgb(120,140,59)", "rgb(189,155,244)", "rgb(11,83,19)", "rgb(191,17,175)", "rgb(9,245,76)", "rgb(252,84,104)", "rgb(21,151,77)", "rgb(242,127,245)", "rgb(104,175,252)", "rgb(206,126,43)", "rgb(83,16,240)", "rgb(211,203,4)", "rgb(47,91,177)", "rgb(254,89,0)", "rgb(118,72,13)"
    , "rgb(57,146,131)", "rgb(135,212,207)", "rgb(21,78,86)", "rgb(96,238,163)", "rgb(55,136,17)", "rgb(173,213,31)", "rgb(113,53,41)", "rgb(231,134,7)", "rgb(224,191,180)", "rgb(247,57,58)", "rgb(192,49,109)", "rgb(246,141,146)", "rgb(141,129,132)", "rgb(243,212,38)", "rgb(73,56,142)", "rgb(254,121,236)", "rgb(135,17,172)", "rgb(106,159,238)", "rgb(142,128,251)", "rgb(37,36,249)", "rgb(250,27,252)", "rgb(63,76,8)", "rgb(101,241,18)"
    , "rgb(72,191,142)", "rgb(35,94,49)", "rgb(198,219,174)", "rgb(49,99,135)", "rgb(121,172,253)", "rgb(104,82,152)", "rgb(231,117,204)", "rgb(172,24,136)", "rgb(20,186,225)", "rgb(80,16,200)", "rgb(124,238,77)", "rgb(131,151,109)", "rgb(89,162,12)", "rgb(104,60,0)", "rgb(247,184,162)", "rgb(144,14,8)", "rgb(247,118,125)", "rgb(255,28,93)", "rgb(181,117,62)", "rgb(255,185,71)", "rgb(240,102,20)", "rgb(226,217,35)", "rgb(183,79,255)"
];


export default class CommentList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            orderId: props.orderId,
            visitId: props.visitId,
            list: [],
            loaded: false,
            item: {},
            lastID: 0
        }
        this.load = this.load.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmitComment = this.onSubmitComment.bind(this);
    }

    componentDidMount() {
        this.load(true);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.orderId !== this.props.orderId) {
            this.setState({ orderId: this.props.orderId });
            this.load();
        }
        if (prevProps.visitId !== this.props.visitId) {
            this.setState({ visitId: this.props.visitId });
            this.load();
        }
        if (prevProps.hash !== this.props.hash) {
            this.load(true);
        }
    }

    load(reset) {
        var lastID = this.state.lastID;
        if (reset) {
            this.setState({ lastID: 0 });
            lastID = 0;
        }
        if (this.props.visitId) {
            qreq.get('/api/comment/list/visit/' + this.props.visitId + '?lastID=' + lastID + (this.props.isSystem !== undefined ? '&isSystem=' + this.props.isSystem : '') + (this.props.commentType !== undefined ? '&commentType=' + this.props.commentType : ''), j => {
                if (j.errorCode === 0) {
                    if (reset || !this.state.list)
                        this.setState({ list: j.list, loaded: true, lastID: j.list.at(-1)?.id ?? 0 });
                    else {
                        var list = [...this.state.list, ...j.list];
                        this.setState({ list: list, loaded: true, lastID: j.list.at(-1)?.id ?? 0, eol: j.list.length === 0 });
                    }
                    this.scrollTo();
                }
                else
                    this.alert(j.errorMessage);
            });
        }
        else if (this.props.orderId) {
            qreq.get('/api/comment/list/order/' + this.props.orderId + '?lastID=' + lastID + (this.props.isSystem !== undefined ? '&isSystem=' + this.props.isSystem : '') + (this.props.commentType !== undefined ? '&commentType=' + this.props.commentType : ''), j => {
                if (j.errorCode === 0) {
                    if (reset || !this.state.list)
                        this.setState({ list: j.list, loaded: true, lastID: j.list.at(-1)?.id ?? 0 });
                    else {
                        var list = [...this.state.list, ...j.list];
                        this.setState({ list: list, loaded: true, lastID: j.list.at(-1)?.id ?? 0, eol: j.list.length === 0 });
                    }
                    this.scrollTo();
                }
                else
                    this.alert(j.errorMessage);
            });
        }
    }

    scrollTo() {
        setTimeout(() => {
            var ps = document.location.hash;
            if (ps && ps.indexOf('#comment-') === 0) {
                var id = ps.substring(9);
                document.getElementById('comment-' + id)?.scrollIntoView();
            }
        }, 100);
    }

    onChange(v) {
        this.setState({ item: { ...this.state.item } });
    }

    onSubmitComment(e) {
        e?.preventDefault();
        if (this.state.visitId)
            this.state.item.visitId = this.state.visitId;
        else if (this.state.orderId)
            this.state.item.orderId = this.state.orderId;
        qreq.post('/api/comment/post', this.state.item, j => {
            if (j.errorCode === 0) {
                this.load(true);
                this.setState({ item: {} });
                this.success('Your comment has been posted below.');
            }
            else
                this.alert(j.errorMessage);
        });
    }

    render() {
        if (!this.props.orderId && !this.props.visitId)
            return <Alert><L>Please save the record before adding notes.</L></Alert>;
        if (!this.state.loaded)
            return <LoadingAlert />


        return <>
            {this.props.noForm ? <Card title="Add a note">
                <FormInput model={this.state.item} name="message" label="Message" type="textarea" rows={5} placeholder="Write a note here..." onChange={this.onChange} />
                <div className="btn-group">
                    <button type="submit" className="btn btn-primary" disabled={!this.state.item.message} onClick={() => this.onSubmitComment()}><L>Submit Comment</L></button>
                </div>
            </Card>
                : <form onSubmit={this.onSubmitComment}>
                    <Card title="Add a comment">
                        <FormInput model={this.state.item} name="message" label="Message" type="textarea" required rows={2} placeholder="Write a comment here..." onChange={this.onChange} />
                        <div className="btn-group">
                            <button type="submit" className="btn btn-primary" disabled={!this.state.item.message}><L>Submit Comment</L></button>
                        </div>
                        {this.props.orderId && !this.props.isLead ? <p className="mt-2"><L>Are you looking to add a note instead?</L> <Link to={'/order/view/' + this.props.orderId + '/notes'}><L>Go to the Notes tab</L></Link>
                        </p> : ''}
                    </Card>
                </form>}
            <div className="comment-list">
                {this.state.list.map(obj =>
                    <div key={obj.id} className="comment-item">
                        <div id={'comment-' + obj.id}>
                            <div className="d-flex justify-content-start align-items-start">
                                <div className="comment-avatar" style={{ backgroundColor: colorMap[obj.createdByUserName?.toUpperCase().charCodeAt(0) - 'A'.charCodeAt(0)] }}>
                                    {obj.createdByUserName?.substring(0, 2)?.toLowerCase()}
                                </div>
                                <div className="p-1 flex-fill">
                                    <div className="d-flex">
                                        <div className="flex-fill"><strong>{obj.createdByUserName}</strong></div>
                                        <div><span className="text-muted">{Globals.toMDYHMLocalDateString(obj.createdDate)}</span></div>
                                    </div>
                                    {this.state.orderId && obj.visitID ? <i><L>for</L><Link to={'/visit/view/' + obj.visitID}> encounter scheduled on {Globals.toMDYHMLocalDateString(obj.visitScheduleDate)}</Link></i> : ''}
                                    <div className="mt-2" dangerouslySetInnerHTML={{ __html: this.processComment(obj.message) }}></div>
                                </div>
                            </div>
                        </div>
                    </div>)}
            </div>
            <ScrollHandler onScroll={() => this.load()} end={this.state.eol} />
        </>;

    }
}